import { isOfflinePeopleDataViaPDVEnabled } from 'owa-offline-sync-feature-flags';
import type { MailboxInfo } from 'owa-client-types';
import { getApplicationSettings } from 'owa-application-settings';

export const isLivePersonaEditorEnabled = (mailboxInfo: MailboxInfo): boolean =>
    getApplicationSettings('Jana').lpeNova &&
    getApplicationSettings('Jana').peopleNovaPeopleApp &&
    isOfflinePeopleDataViaPDVEnabled(mailboxInfo);
